import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconImac"><Path d="M4.5 3C3.11929 3 2 4.11929 2 5.5V13H22V5.5C22 4.11929 20.8807 3 19.5 3H4.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 15.5V14H22V15.5C22 16.8807 20.8807 18 19.5 18H15V21.5C15 21.7761 14.7761 22 14.5 22H9.5C9.22386 22 9 21.7761 9 21.5V18H4.5C3.11929 18 2 16.8807 2 15.5ZM10 18V21H14V18H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
